/* eslint-disable no-use-before-define */
import { gql } from "@apollo/client";

export const UPDATE_CUSTOMER_EMAIL_ADDRESS = gql`
  mutation updateCustomerEmailAddress($token: String!) {
    updateCustomerEmailAddress(token: $token) {
      ... on Success {
        success
        __typename
      }

      ... on ErrorResult {
        errorCode
        message
        __typename
      }
      __typename
    }
  }
`;
